const state = {
  socketAuth: false
}

const getters = {
  IS_SOCKET_AUTH: state => !!state.socketAuth
}

const actions = {
  SOCKET_AUTHENTICATE({ commit }) {
    commit('SOCKET_AUTH')
  }
}

const mutations = {
  SOCKET_AUTH(state) {
    state.socketAuth = true
  },
  RESET_SOCKET_AUTH(state) {
    state.socketAuth = false
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
